const getters = {
  getId: (state) => state.id,
  getFullName: (state) => state.full_name,
  getTelephone: (state) => state.telephone,
  getEmail: (state) => state.email,
  getPostcode: (state) => state.postcode,
  getAddressCity: (state) => state.address_city,
  getAddressStreet: (state) => state.address_street,
  getAddressStreetNumber: (state) => state.address_street_number,
  getAddressStreetDistrict: (state) => state.address_street_district,
  getAddressStreetComplement: (state) => state.address_street_complement,
  getAddressState: (state) => state.address_state,
  getCustomer: ({
    full_name,
    telephone,
    email,
    national_number,
    country_code,
    document_number,
  }) => ({
    full_name,
    telephone,
    email,
    national_number,
    country_code,
    document_number,
  }),
  getAddress: (state) => ({
    postcode: state.postcode,
    address_city: state.address_city,
    address_street: state.address_street,
    address_street_number: state.address_street_number,
    address_street_district: state.address_street_district,
    address_street_complement: state.address_street_complement,
    address_state: state.address_state,
  }),
  getDocumentNumber: (state) => state.document_number,
}

export default getters
